
        import 'PremiumDetails.a11831e.css-module'
        export default {"PremiumDetails":"PremiumDetails_PremiumDetails_a11831e","Cost":"Cost_PremiumDetails_a11831e","Month":"Month_PremiumDetails_a11831e","Year":"Year_PremiumDetails_a11831e"}
    